import { render, staticRenderFns } from "./complaintsExperience.vue?vue&type=template&id=5f3ce74e&scoped=true"
import script from "./complaintsExperience.vue?vue&type=script&lang=js"
export * from "./complaintsExperience.vue?vue&type=script&lang=js"
import style0 from "./complaintsExperience.vue?vue&type=style&index=0&id=5f3ce74e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3ce74e",
  null
  
)

export default component.exports